<template>
  <div>
    <div class="crystal-box">
      <div class="crystal-content">
        <!-- <div class="time">活動時間：2022/11/11 - 2022/11/25 23:59:59</div> -->
        <div class="card-box">
          <div class="flash">
            <img class="left-img" src="./images/left-flash.png" alt="" />
            <img class="right-img" src="./images/right-flash.png" alt="" />
          </div>
          <img class="left" src="./images/left.png" alt="" @click="checkType" />
          <div class="card-tabs">
            <div
              :class="{ active: isSilverCard }"
              @click.stop="swipingCard('DoubleElevenlottery2')"
              :style="
                isGrayscale
                  ? { filter: 'grayscale(0.75)' }
                  : { filter: 'grayscale(0)' }
              "
            >
              銀卡
            </div>
            <div
              :class="{ active: !isSilverCard }"
              @click.stop="swipingCard('DoubleElevenlottery1')"
              :style="
                isGrayscale
                  ? { filter: 'grayscale(0.75)' }
                  : { filter: 'grayscale(0)' }
              "
            >
              金卡
            </div>
          </div>
          <img
            class="right"
            src="./images/right.png"
            alt=""
            @click="checkType"
          />
        </div>
        <div class="gold-crad">
          <div class="gold-crad-box">
            <LuckyWheel
              ref="myLucky"
              :width="luckyDrawGold.width"
              :height="luckyDrawGold.height"
              :prizes="luckyDrawGold.prizes"
              :blocks="
                activeType === 'DoubleElevenlottery1'
                  ? luckyDrawGold.blocks
                  : luckyDrawSilver.blocks
              "
              :buttons="luckyDrawGold.buttons"
              :default-config="luckyDrawGold.defaultConfig"
              @start="startLuckDraw"
              @end="endLuckDraw"
            />
          </div>
        </div>
        <div class="swiping-card">
          <div class="progress-content">
            <div class="draw-container">
              <img
                class="draw-progress"
                src="./images/progress-bg.png"
                alt=""
                :style="{ left: progressWidth }"
              />
            </div>
            <div class="target">
              <span
                v-for="(item, index) of targetList"
                :key="index"
                :style="{ left: item + '%' }"
                >{{ item }}</span
              >
            </div>
          </div>
          <div class="card-text">
            當前我的刷卡次數為 <span>{{ cardNum }}</span>
          </div>
          <div class="card-text">
            距離下一個目標還需要刷 <span>{{ targetDistance }}</span> 次卡
          </div>
        </div>
        <div class="candies-box">
          <div class="candies-balance">{{ crystalBalance }}</div>
          <img
            class="rules-img"
            src="./images/rules.png"
            alt=""
            @click="isShowRulesDialog = !isShowRulesDialog"
          />
          <el-dialog
            :visible.sync="isShowRulesDialog"
            title="糖果獲得規則說明："
            center
            :modal-append-to-body="false"
          >
            <div class="rules-item">
              1. 確認完成陪玩訂單，用戶和陪玩師雙方都可獲得訂單實付金額相同數量的糖果；
            </div>
            <div class="rules-item">
              2. 完成陪玩服務訂單：送出禮物方可獲得禮物訂單金額數量4倍的糖果，收到禮物方可獲得禮物訂單金額數量2倍的糖果；
            </div>
            <div class="rules-item">
              3. 糖果長期有效，更多神秘用途正在路上
            </div>
          </el-dialog>
        </div>
        <div class="swiping-rules">
          <div>
            1.
            點擊“銀卡”“金卡”按鈕可開始刷卡！每花費200個糖果可兌換一張銀卡，每花費400個糖果可兌換一張金卡；金卡銀卡轉盤的獎勵不相同喔，點擊“▶
            ”處可切換轉盤查看；
          </div>
          <div>2、當累計刷卡次數達到目標刷卡數時，平台會給予你獎勵。</div>
          <div class="tips">(獎勵發放會有系統通知，敬請留意)</div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-bg"
      :visible.sync="showWinningDialog"
      title="恭喜你！"
      center
      :modal-append-to-body="false"
      :show-close="false"
    >
      <span class="prize">幸運地抽中了：{{ this.drawName }}*1份</span>
      <img class="img-dialog" :src="drawSrc" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showWinningDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="dialog-lose-bg"
      :visible.sync="showLoseDialog"
      title="很遺憾"
      center
      :modal-append-to-body="false"
      :show-close="false"
    >
      <span>本次您沒抽到獎品，謝謝參與</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showLoseDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
export default {
  name: 'MinCrystalFourth',
  data() {
    return {
      drawName: '', // 獎品名稱
      // 銀輪盤配置
      luckyDrawSilver: {
        blocks: [
          {
            padding: '40px',
            imgs: [
              {
                src: require('./images/wheel-border.png'),
                width: '100%',
                height: '100%'
              }
            ]
          },
          {
            imgs: [
              {
                src: require('./images/wheel-bg.png'),
                width: '100%',
                height: '100%',
                rotate: true
              }
            ]
          }
        ]
      },
      // 金輪盤配置
      luckyDrawGold: {
        width: '356px',
        height: '356px',
        blocks: [
          {
            padding: '40px',
            imgs: [
              {
                src: require('./images/wheel-border.png'),
                width: '100%',
                height: '100%'
              }
            ]
          },
          {
            imgs: [
              {
                src: require('./images/gold-bg.png'),
                width: '100%',
                height: '100%',
                rotate: true
              }
            ]
          }
        ],
        prizes: [
          { title: '0' },
          { title: '1' },
          { title: '2' },
          { title: '3' },
          { title: '4' },
          { title: '5' },
          { title: '6' },
          { title: '7' }
        ],
        buttons: [
          {
            radius: '45%',
            imgs: [
              {
                src: require('./images/wheel-btn.png'),
                width: '100%',
                top: '-150%'
              }
            ]
          }
        ],
        defaultConfig: {
          speed: 8
        }
      },
      isShow: false,
      drawResult: {}, // 抽獎獎品
      crystalBalance: 0, // 糖果餘額
      activeType: 'DoubleElevenlottery2', // 刷卡類型
      cardNum: 0, // 刷卡次數
      luckIndex: 0, // 輪盤獎品序號
      isShowRulesDialog: false, // 展示規則彈框
      targetList: [], // 刷卡次數目標檔位
      activityInfo: {},
      showWinningDialog: false,
      showLoseDialog: false,
      drawing: false, // 是否正在抽獎
      isGrayscale: false // 是否置灰
    };
  },
  created() {
    this.getActivityInfo();
  },
  methods: {
    // 設置目標值樣式
    // :class="setTargetClass(item, index)"
    // setTargetClass(val) {
    //   const list = [1, 50, 100];
    //   let className = '';
    //   if (list.includes(val)) {
    //     className += 'larget-font';
    //   }
    //   return className;
    // },
    // 每達到一個目標彈窗提示
    showTarget() {
      this.targetList.forEach(item => {
        if (this.lotteryCount === item) {
          this.$confirm({
            title: '恭喜你',
            message: `一個小目標輕輕鬆鬆被拿下，請留意系統通知發送獎勵${this.drawName}`,
            confirmButtonText: '確定',
            className: 'dialog-center'
          });
        }
      });
    },
    // 点击抽奖按钮会触发start回调
    async startLuckDraw() {
      // 檢查登錄
      await this.checkLogin();
      if (this.drawing) {
        return;
      }
      let drawCount = this.activityInfo.lotteryAmount[this.activeType] || 0;
      if (drawCount > 0) {
        this.$confirm({
          title: '提示',
          message: `當前您擁有${drawCount}次抽獎機會，點擊確定開始抽獎`,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'dialog-center'
        })
          .then(() => {
            this.getDrawResult();
          })
          .catch(() => {});
      } else {
        this.$confirm({
          title: '提示',
          message:
            '抱歉，您當前無法參與本次抽獎，刷銀卡、金卡都可以獲得抽獎機會喔',
          confirmButtonText: '確定',
          className: 'dialog-center'
        });
      }
    },
    // 切換卡類型
    checkType() {
      this.activeType =
        this.activeType === 'DoubleElevenlottery1'
          ? 'DoubleElevenlottery2'
          : 'DoubleElevenlottery1';
    },
    // 刷卡
    swipingCard(cardType) {
      if (cardType != this.activeType) {
        this.checkType();
      }
      if (this.lotteryCount < 100) {
        this.$confirm({
          title: '提示',
          message: `是否花費${this.crystalRate}個糖果進行刷${
            this.activeType === 'DoubleElevenlottery1' ? '金卡' : '銀卡'
          }？`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'dialog-center'
        })
          .then(() => {
            if (this.crystalBalance >= this.crystalRate) {
              this.getDrawCount();
            } else {
              this.$confirm({
                title: '抱歉',
                message: '您當前所擁有的糖果餘額數量不足以刷卡哦',
                confirmButtonText: '確定',
                className: 'dialog-center'
              });
            }
          })
          .catch(() => {
            console.log('swipingCard', this.activeType);
          });
      } else {
        this.isGrayscale = true;
      }
    },

    // 獲取活動信息詳情
    async getActivityInfo() {
      try {
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo'
        );

        this.lotteryCount = data.lotteryCount || 0;
        this.targetList = data.gearList || [];
        this.crystalBalance = data.crystalBalance || 0;
        this.activityInfo = data;
      } catch (error) {
        console.log('');
      }
    },
    // 获取可抽奖次数
    async getDrawCount() {
      try {
        const { data } = await this.$http.get('/activity/discount', {
          dictType: this.activeType
        });
        if (data) {
          this.activityInfo.lotteryAmount[this.activeType] = data;
          this.lotteryCount++;
          this.crystalBalance -= this.crystalRate;
          this.$confirm({
            title: '刷卡成功！',
            message: '点击对应转盘“立即抽奖”吧！',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: false,
            className: 'dialog-center'
          }).then(() => {
            this.showTarget();
          });
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    // 獲取抽獎結果
    async getDrawResult() {
      this.drawing = true;
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: this.activeType
        });
        if (data) {
          this.drawResult = data;
          this.drawName = data.prizeName || '';
          this.activityInfo.lotteryAmount[this.activeType] -= 1;
          this.startLuck();
        }
        // this.drawResult.no = 'P08';
        // this.startLuck();
        this.drawing = false;
      } catch (error) {
        console.log('抽獎失敗');
        this.drawing = false;
        this.$refs.myLucky.init();
      }
    },
    // 開始抽獎
    startLuck() {
      if (this.activeType === 'DoubleElevenlottery2') {
        switch (this.drawResult.no) {
          case 'P01':
            this.luckIndex = 0; // 9折优惠券
            break;
          case 'P04':
            this.luckIndex = 1; // 100代金券
            break;
          case 'P06':
            this.luckIndex = 2; // 20代金券
            break;
          case 'P02':
            this.luckIndex = 3; // 7折優惠券
            break;
          case 'P07':
            this.luckIndex = 4; // 15代金券
            break;
          case 'P03':
            this.luckIndex = 5; // 5折優惠券
            break;
          case 'P05':
            this.luckIndex = 6; // 50代金券
            break;
          case 'P08':
            this.luckIndex = 7; // 謝謝參與
            break;
          default:
            break;
        }
      } else {
        switch (this.drawResult.no) {
          case 'P01':
            this.luckIndex = 0; // 120鑽石
            break;
          case 'P02':
            this.luckIndex = 5; // 88鑽石
            break;
          case 'P03':
            this.luckIndex = 1; // 8折優惠券
            break;
          case 'P04':
            this.luckIndex = 2; // 6折優惠券
            break;
          case 'P05':
            this.luckIndex = 3; // 5折優惠券
            break;
          case 'P06':
            this.luckIndex = 4; // 4折優惠券
            break;
          case 'P07':
            this.luckIndex = 6; // 100代金券
            break;
          case 'P08':
            this.luckIndex = 7; // 免單優惠券
            break;
          default:
            break;
        }
      }
      this.startCallback();
    },
    // 輪盤轉動
    startCallback() {
      // 模拟调用接口异步抽奖
      setTimeout(() => {
        // 调用stop停止旋转并传递中奖索引
        this.$refs.myLucky.stop(this.luckIndex);
      }, 2000);
    },
    // 抽獎結束，輪盤停止
    endLuckDraw() {
      if (this.activeType === 'DoubleElevenlottery2' && this.luckIndex === 7) {
        this.$confirm({
          title: '很遺憾',
          message: '本次你沒有抽到獎品，謝謝參與',
          confirmButtonText: '確定',
          className: 'dialog-bg-lose'
        });
      } else {
        this.showWinningDialog = true;
      }
    },
    // 检查登录
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token', 'refreshToken']),
    // 距離下個目標獎勵數量
    targetDistance() {
      try {
        const lastTarget = this.targetList.find(item => {
          return item > this.lotteryCount;
        });
        return lastTarget - this.lotteryCount > 0
          ? lastTarget - this.lotteryCount
          : 0;
      } catch (error) {
        return 0;
      }
    },
    // 是否為銀卡類型
    isSilverCard() {
      return this.activeType === 'DoubleElevenlottery2';
    },
    //每達到1張，進度條動態變化
    progressWidth() {
      const lotteryCount = this.lotteryCount || 0;
      if (lotteryCount < 100) {
        return '-' + (100 - lotteryCount) + '%';
      } else {
        return 0;
      }
    },
    // 糖果兑换卡类型比率
    crystalRate() {
      return this.activeType === 'DoubleElevenlottery1' ? 400 : 200;
    },
    // 彈窗內的獎品圖片
    drawSrc() {
      let src = '';
      const diamond = require('./images/diamond.png');
      const coupon = require('./images/discount-coupon.png');
      const free = require('./images/free.png');
      const voucher = require('./images/voucher.png');
      try {
        if (this.activeType === 'DoubleElevenlottery2') {
          switch (this.drawResult.no) {
            case 'P01':
              src = coupon; // 9折优惠券
              break;
            case 'P04':
              src = voucher; // 100代金券
              break;
            case 'P06':
              src = voucher; // 20代金券
              break;
            case 'P02':
              src = coupon; // 7折優惠券
              break;
            case 'P07':
              src = voucher; // 15代金券
              break;
            case 'P03':
              src = coupon; // 5折優惠券
              break;
            case 'P05':
              src = voucher; // 50代金券
              break;
            default:
              src = '';
              break;
          }
        } else {
          switch (this.drawResult.no) {
            case 'P01':
              src = diamond; // 120鑽石
              break;
            case 'P03':
              src = coupon; // 8折優惠券
              break;
            case 'P05':
              src = coupon; // 5折優惠券
              break;
            case 'P06':
              src = coupon; // 4折優惠券
              break;
            case 'P04':
              src = coupon; // 6折優惠券
              break;
            case 'P02':
              src = diamond; // 88鑽石
              break;
            case 'P07':
              src = voucher; // 100代金券
              break;
            case 'P08':
              src = free; // 免費優惠券
              break;
            default:
              src = '';
              break;
          }
        }
      } catch (error) {
        src = '';
      }

      return src;
    }
  }
};
</script>
<style lang="scss" scoped>
.crystal-box {
  display: flex;
  justify-content: center;
  background-color: #f471a8;
}
.crystal-content {
  width: 375px;
  height: 1444px;
  background: url('./images/bg.png') no-repeat center top;
  background-size: cover;
  padding-top: 228px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // .time {
  //   height: 29px;
  //   margin-bottom: 40px;
  //   font-weight: 500;
  //   font-size: 14px;
  //   line-height: 14px;
  //   color: #52093e;
  // }
  .card-box {
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .flash {
      // width: calc(100vw + 130px);
      width: 375px;
      overflow: hidden;
      position: absolute;
      top: 30px;
      display: flex;
      justify-content: space-between;
      z-index: 1;
      > img {
        width: 100px;
        height: 133px;
      }
      .right-img {
        margin-right: -34px;
      }
      .left-img {
        margin-left: -34px;
      }
    }
    .left,
    .right {
      width: 8px;
      height: 10px;
      margin: 12px;
    }
  }
  .card-tabs {
    font-size: 16px;
    font-weight: 500;
    color: #92d3d1;
    width: 228px;
    height: 42px;
    background: url('./images/tabs-bg.png') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 6px;
    > div {
      width: 108px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      margin-bottom: 4px;
    }
    .active {
      background: url('./images/tab-active.png') no-repeat center center;
      background-size: 100% 100%;
      color: #222c43;
    }
  }
  .swiping-card {
    margin-top: 65px;
    width: 309px;
    height: 128px;
    padding: 7px 6px;
    .progress-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 297px;
      height: 60px;
    }
    .target {
      position: relative;
      font-size: 16px;
      width: 282px;
      height: 18px;
      margin-top: 4px;
      > span {
        position: absolute;
        font-size: 16px;
        // transform: translateX(-50%);

        // &.larget-font {
        //   font-size: 16px;
        // }
        &:first-child {
          left: 0 !important;
          transform: translateX(-30%);
        }
        &:last-child {
          transform: translateX(-100%);
        }
      }
    }
    .card-text {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #0b1b32;
      padding: 0 2px;
      > span {
        font-weight: 600;
        color: #e22071;
      }
    }
  }
  .candies-box {
    width: 100%;
    margin-top: 36px;
    height: 40px;
    padding-right: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /deep/ .el-dialog {
      border-radius: 14px;
      width: 300px;

      .el-dialog__body {
        font-size: 14px;
        padding-top: 10px;
        .rules-item {
          margin-bottom: 10px;
        }
      }
    }
    .candies-balance {
      padding-right: 4px;
      width: 150px;
      overflow: auto;
      color: #ffffff;
      font-size: 28px;
      line-height: 28px;
      text-align: right;
      text-shadow: 0 0 3px #52093e, 0 0 3px #52093e, 0 0 3px #52093e,
        0 0 3px #52093e;
      // filter: drop-shadow(0 0 0.2px #52093e) drop-shadow(0 0 0.2px #52093e)
      //   drop-shadow(0 0 0.2px #52093e) drop-shadow(0 0 0.2px #52093e);
    }
    .rules-img {
      margin-left: 25px;
      width: 18px;
      height: 18px;
    }
    // /deep/.van-dialog {
    //   overflow: visible;
    // }
    .rules-dialog {
      position: relative;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      display: flex;
      flex-direction: column;
      // align-items: center;
      .title {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 15px;
        text-align: center;
      }
      .rules-item {
        margin-bottom: 10px;
      }
      .close {
        width: 20px;
        height: 20px;
        position: absolute;
        right: -10px;
        top: -74px;
      }
    }
  }
  .swiping-rules {
    margin-top: 80px;
    width: 328px;
    height: 390px;
    color: #0b1b32;
    font-size: 14px;
    line-height: 21px;
    display: flex;
    flex-direction: column;
    // align-items: center;
    padding: 20px;
    .tips {
      margin-top: 6px;
      color: #777c84;
    }
  }
  .draw-container {
    width: 282px;
    height: 16px;
    border-radius: 100px;
    background-color: #a42158;
    overflow: hidden;
    border: 1px solid #52093e;
    position: relative;
    .draw-progress {
      position: absolute;
      max-width: 100%;
    }
  }
  .gold-crad-box {
    // width: 6.96rem;
    // height: ;
    border-radius: 50%;
    box-shadow: 0 5px 0 #52093e;
  }
}
</style>
<style lang="scss">
.dialog-bg {
  .el-dialog {
    width: 267px;
    height: 300px;
    background: url('./images/win-bg.png') no-repeat;
    background-size: cover;
    // padding-top: 80px;
  }
  .el-dialog__body {
    height: 154px;
    padding-top: 0;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
  }
  .el-dialog__header {
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    padding-top: 35px;
    .el-dialog__title {
      color: #d756a3;
    }
  }
  .el-dialog__footer {
    .el-button {
      width: 140px;
      height: 40px;
      border-radius: 50px;
      > span {
        color: #222c43;
      }
    }
  }
}
</style>
